module.exports = __webpack_public_path__ + "static/img/08_address.5888b87.png";